import { render, staticRenderFns } from "./SearchResult.vue?vue&type=template&id=2644fbcc&scoped=true"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"
import style0 from "./SearchResult.vue?vue&type=style&index=0&id=2644fbcc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2644fbcc",
  null
  
)

export default component.exports